import { render } from "./ProjectReferenceMountain.vue?vue&type=template&id=9d248138"
import script from "./ProjectReferenceMountain.vue?vue&type=script&lang=js"
export * from "./ProjectReferenceMountain.vue?vue&type=script&lang=js"

import "./ProjectReferenceMountain.vue?vue&type=style&index=0&id=9d248138&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__